import { useState, useEffect } from "react";
import { setDoc, doc, getDoc, updateDoc } from "firebase/firestore";
import { db, applicantsCol } from "../../firebase";
import "../../dash.css";
import { useUser } from "../../UserContext";

export const Sponser_info = ({ onSuccess }) => {
  const { user, loading: userLoading } = useUser();
  const userID = user?.uid || "";
  const [isNewApplicant, setIsNewApplicant] = useState(true);
  const [hasSavedSponserInfo, setHasSavedSponserInfo] = useState(false);
  const [issavingData, setIssavingData] = useState(false);
  const [disableInputFields, setDisableInputFields] = useState(false);
  const [message, setMessage] = useState("");
  const [isErrorOrSuccMsg, setIsErrorOrSuccMsg] = useState(false);
  const [isErrorMsg, setIsErrorMsg] = useState(false);
  const [formData, setformData] = useState({
    sponserfName: "",
    sponserEmail: "",
    sponserPhoneNo: "",
    sponserAddress: "",
    scholarship: "",
  });
  const [loading, setIsloading] = useState(false);

  // get applicants details if aready registered
  useEffect(() => {
    if (!userID) return;
    const fetchApplicantDetails = async () => {
      setIsloading(true);
      const applicantRef = doc(db, applicantsCol, userID);
      const registeredApplicant = await getDoc(applicantRef);
      if (registeredApplicant.exists()) {
        setIsNewApplicant(false);
        const data = registeredApplicant.data();
        if (data.savedSponserInfo) {
          setHasSavedSponserInfo(true);
          setDisableInputFields(true);

          setformData((prev) => ({
            ...prev,
            sponserfName: data.sponserfName,
            sponserEmail: data.sponserEmail,
            sponserPhoneNo: data.sponserPhoneNo,
            sponserAddress: data.sponserAddress,
            scholarship: data.scholarship
          }));
          setIsloading(false);
        } else {
          setIsloading(false);
          setHasSavedSponserInfo(false);
          setDisableInputFields(false);
        }
      } else {
        setIsloading(false);
        setIsNewApplicant(false);
        setDisableInputFields(false);
      }
    };

    fetchApplicantDetails();
  }, [userID]);

  const handleChange = (e) => {
    setformData((prev) => ({
      ...prev,
      savedSponserInfo: true,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIssavingData(true);

    try {
      if (isNewApplicant) {
        await setDoc(doc(db, applicantsCol, userID), formData);
        setIssavingData(false);
        setIsErrorOrSuccMsg(true);
        setIsErrorMsg(false);
        setMessage("information saved successfully");
        setDisableInputFields(true);
        if (typeof onSuccess === "function") {
          onSuccess();
        }
      } else {
        const applicantRef = doc(db, applicantsCol, userID);
        await updateDoc(applicantRef, formData);
        setIssavingData(false);
        setIsErrorOrSuccMsg(true);
        setIsErrorMsg(false);
        setMessage("information updated successfully");
        setDisableInputFields(true);
        // if (typeof onSuccess === "function") {
        //   onSuccess();
        // }
      }
    } catch (error) {
      setIssavingData(false);
      setIsErrorOrSuccMsg(true);
      setIsErrorMsg(true);
      setMessage("something went wrong, try again");
    }
  };

  const enableFields = () => {
    setDisableInputFields(false);
    setIsErrorOrSuccMsg(false);
    setHasSavedSponserInfo(true);
  };

  if (loading) return <div className="loader"></div>;

  return (
    <div className="form-container personal-info">
      {isErrorOrSuccMsg ? (
        <div
          className={`alert alert-${isErrorMsg ? "danger" : "success"}`}
          role="alert"
        >
          {message}
        </div>
      ) : (
        <span></span>
      )}

      <h2 className="form-title">SPONSOR INFORMATION</h2>
      {/* <span style={{color}}>{message}</span> */}
      {disableInputFields ? (
        <button className="btn btn-primary" onClick={enableFields}>
          CHANGE
        </button>
      ) : (
        <span></span>
      )}

      <form onSubmit={handleSubmit}>
        <div className="details">
          <div className="form-fields">
            <label>
              first name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              placeholder="Enter full  name"
              name="sponserfName"
              value={formData.sponserfName}
              onChange={handleChange}
              required
              maxLength={80}
              disabled={disableInputFields}
            />
          </div>

          <div className="form-fields">
            <label>
              email
            </label>
            <input
              type="email"
              name="sponserEmail"
              value={formData.sponserEmail}
              onChange={handleChange}
              placeholder="Enter sponser email"
              disabled={disableInputFields}

            />
          </div>

          <div className="form-fields">
            <label>phone number <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="sponserPhoneNo"
              value={formData.sponserPhoneNo}
              onChange={handleChange}
              placeholder="phone number"
              maxLength={15}
              disabled={disableInputFields}
              required

            />
          </div>

          <div className="form-fields">
            <label>address <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="sponserAddress"
              value={formData.sponserAddress}
              onChange={handleChange}
              placeholder="sponser address"
              maxLength={15}
              disabled={disableInputFields}
              required
            />
          </div>
          <div className="form-fields">
            <label>
              Request Scholarship
            </label>
            <select
              name="scholarship"
              id="scholarship"
              value={formData.scholarship}
              onChange={handleChange}
              disabled={disableInputFields}
              
            >
              {/* <option value="">--do you need scholarship--</option> */}
              <option value="yes">YES</option>
              <option value="no">NO</option>
            </select>
          </div>
        </div>
        {disableInputFields ? (
          <span></span>
        ) : issavingData ? (
          <div className="loader"></div>
        ) : (
          <button
            type="submit"
            style={hasSavedSponserInfo ? { background: "green" } : {}}
          >
            {hasSavedSponserInfo ? "update" : "save"}
          </button>
        )}
      </form>
    </div>
  );
};
